module.exports = __webpack_public_path__ + "img/title_CH.7b65f974.png";